import { FreeResponseFrame } from 'FreeResponseFrame';
import { type FrameInterface, type InitFrameAttrs } from 'Lessons';

const NonIguanaFrameTypes = {
    FreeResponse: FreeResponseFrame,
};

// This is overridden in specs in vendor/front-royal/modules/Lessons/angularModule/spec/_mock/fixtures/lessons.js
export function initializeFrameFromAttrs(
    attrs: InitFrameAttrs,
    IguanaFrame: { new: (_attrs: InitFrameAttrs) => FrameInterface },
): FrameInterface {
    if (attrs.frame_type === 'componentized') {
        return IguanaFrame.new(attrs);
    }
    const frameType = attrs.frame_type;
    if (!frameType) {
        throw new Error('Frame type is required');
    }
    const klass = NonIguanaFrameTypes[frameType as keyof typeof NonIguanaFrameTypes];
    if (!klass) {
        throw new Error(`Frame type '${frameType}' not found`);
    }
    return klass.new(attrs);
}
